import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { VaultFolder } from './../../dataService/dto/VaultFolder';
import { FolderType } from '../../dataService/dto/FolderType';

@customElement('committee-accordion')
export class Accordion extends LitElement {
    @property({ type: Boolean }) open = false;
    @property({ type: Object }) folder?: VaultFolder;

    static styles = css`
    .header {
      cursor: pointer;      
      padding: 10px;
      border: 1px solid #ccc;
    }
    .content {
      overflow-y: scroll;
      overflow-x:hidden;
      transition: max-height 0.3s ease;
      max-height: 0;
      background-color: white;
      padding: 0 10px;
    }

    .meetingHeader{
         background-color: #71c2ff;
    }

    .committeeHeader{
        background-color: #f1f1f1;
    }

    .content.open {
      max-height: 1000px; /* Adjust as needed */
    }
  `;

    toggle() {
        this.open = !this.open;

        //scroll a little bit down so that is apparent that the section is open
      

        this.dispatchEvent(new CustomEvent('accordion-toggled', {
            detail: { opening: this.open, folder: this.folder },
            bubbles: false,
            composed: true
        }));
    }


    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('open') && this.open) {
            setTimeout(() => this.scrolltoHeader(),100); // Scroll down 60 pixels
        }
    }

    scrolltoHeader() {
        const header = this.shadowRoot?.querySelector('.header');
        if (header) {
            header.scrollIntoView({ behavior: 'smooth' });            
        }
    }

    close() {
        this.open = false;
    }

    render() {
        return html`
      <div class="header ${classMap({ "meetingHeader": this.folder?.folderType == FolderType.Meeting, "committeeHeader": this.folder?.folderType != FolderType.Meeting })}" @click="${this.toggle}">
        <slot name="header"></slot>
      </div>
      <div class="content ${this.open ? 'open' : ''}">
        <slot name="content"></slot>
      </div>
    `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'committee-accordion': Accordion;
    }
}
